module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#speaker",
      toString: function () {
        return this.url;
      }
    }